/** Miscellaneous query segments */
export const MiscQueryKeys = {
  ipLookup: {
    all: ['ipLookup'] as const,
  },
  channelPreferenceTypes: {
    all: ['channel-preference-types'] as const,
  },
  productCatalogue: {
    search: (search: unknown, offeringUID: string) => [`productCatalogue/search`, { search }, offeringUID] as const,
  },
};
